const entityInitialState = {
  errorData: {
    message: '',
    error: false,
    status: 0,
    statusText: '',
    data: undefined,
    headers: undefined,
    config: undefined,
    request: undefined,
  },
  pagination: {
    totalDocs: 0,
    limit: 25,
    totalPages: 0,
    page: 1,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },
};

export { entityInitialState };
